import { useState } from 'react'

/**
 * AdvisorAvatar
 *
 * Circular profile photo bubble. Shows the advisor's photo if available,
 * falls back to a gold initials circle if not.
 *
 * Props:
 *   avatarUrl  {string|null}      Supabase Storage public URL
 *   fullName   {string}           Used to derive initials for the fallback
 *   size       {'sm'|'md'|'lg'}   sm = 32px, md = 40px, lg = 56px
 *   className  {string}           Optional extra Tailwind classes
 */
export function AdvisorAvatar({ avatarUrl, fullName = '', size = 'md', className = '' }) {
  const [imgError, setImgError] = useState(false)

  const sizeClass = {
    sm: 'w-8 h-8 text-xs',
    md: 'w-10 h-10 text-sm',
    lg: 'w-14 h-14 text-base',
  }[size] ?? 'w-10 h-10 text-sm'

  // Derive initials: "Bartho Erasmus" → "BE", "Zahrah" → "ZA", "" → "?"
  const initials = fullName
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join('') || '?'

  const base = `rounded-full flex-shrink-0 overflow-hidden flex items-center justify-center font-bold ring-2 ring-sfp-orange ${sizeClass} ${className}`

  if (avatarUrl && !imgError) {
    return (
      <div className={base}>
        <img
          src={avatarUrl}
          alt={fullName || 'Advisor'}
          className="w-full h-full object-cover"
          onError={() => setImgError(true)}
        />
      </div>
    )
  }

  return (
    <div className={`${base} bg-sfp-orange text-white`}>
      {initials}
    </div>
  )
}
